import { IResponse } from "../../types";
import { doDelete, doGet, doPostJson } from "../core/http";

export const listGenerations = async (type?: string): Promise<IResponse> => {
    const url = type
        ? `/api/generations?generation_type=${type}`
        : "/api/generations";
    return await doGet(url, true);
};

export const getGeneration = async (id: string): Promise<IResponse> => {
    return await doGet(`/api/generations/${id}`, true);
};

export const getPublicGeneration = async (id: string): Promise<IResponse> => {
    return await doGet(`/api/generations/${id}/public`, false);
};

export const deleteGeneration = async (id: string): Promise<IResponse> => {
    return await doDelete(`/api/generations/${id}`, true);
};

export const deleteGenerations = async (ids: string[]): Promise<IResponse> => {
    const promises = ids.map((id) => deleteGeneration(id));
    const results = await Promise.all(promises);
    const errors = results.filter((result) => result.error);

    if (errors.length > 0) {
        return { error: errors[0].error };
    }

    return { data: true };
};

// Associate image with a generation (shop, tavern, NPC, etc)
export const associateImageWithGeneration = async (
    generationId: string,
    imageData: {
        imageId: string;
        url: string;
        webpUrl?: string;
        associationType: string;
        title: string;
    }
): Promise<{ success: boolean; error?: string }> => {
    try {
        const response = await doPostJson(
            `/api/generations/${generationId}/images`,
            true,
            imageData
        );

        if (response.error) {
            throw new Error(response.error);
        }

        return { success: true };
    } catch (error: any) {
        console.error("Error associating image with generation:", error);
        return {
            success: false,
            error: error.message || "Failed to associate image",
        };
    }
};

// Remove image from a generation (shop, tavern, NPC, etc)
export const removeImageFromGeneration = async (
    generationId: string,
    imageId: string
): Promise<{ success: boolean; error?: string }> => {
    try {
        const response = await doDelete(
            `/api/generations/${generationId}/images/${imageId}`,
            true
        );

        if (response.error) {
            throw new Error(response.error);
        }

        return { success: true };
    } catch (error: any) {
        console.error("Error removing image from generation:", error);
        return {
            success: false,
            error: error.message || "Failed to remove image",
        };
    }
};
